var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"message_item"},[_c('div',{staticClass:"msg_date_wrp"},[_c('span',{staticClass:"msg_date_box"},[_vm._v(_vm._s(_vm.label))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }